import { SimpleIdentity } from './Identity'

export enum SupportTicketCategory {
    BUG = 'BUG',
    FEATURE_REQUEST = 'FEATURE_REQUEST',
    QUESTION = 'QUESTION',
    OTHER = 'OTHER',
}

export enum SupportTicketStatus {
    OPEN = 'OPEN',
    IN_PROGRESS = 'IN_PROGRESS',
    RESOLVED = 'RESOLVED',
    CLOSED = 'CLOSED',
}

export enum SupportTicketSeverity {
    LOW = 'LOW',
    MEDIUM = 'MEDIUM',
    HIGH = 'HIGH',
    CRITICAL = 'CRITICAL',
}

export interface SupportTicketAttachmentRequest {
    filename: string
    contentType: string
    /** Base64 without the data URL prefix. */
    contentBase64: string
}

export interface SupportTicketRequest {
    subject: string
    description: string
    category: SupportTicketCategory
    attachments?: SupportTicketAttachmentRequest[]
}

export interface SupportTicketAttachment {
    id: number
    filename: string
    contentType: string
}

export interface SupportTicket {
    id: number
    dateCreated: number | string
    subject: string
    description: string
    category: SupportTicketCategory
    status: SupportTicketStatus
    severity: SupportTicketSeverity | null
    /**
     * Optional note the admin attached when the ticket transitioned into
     * RESOLVED/CLOSED. Mirrors what was sent in the follow-up email.
     */
    resolutionNote: string | null
    dateResolved: number | string | null
    /** Admin who marked the ticket done. Null until then. */
    resolvedBy: SimpleIdentity | null
    submittedBy: SimpleIdentity
    attachments: SupportTicketAttachment[]
}

export interface SupportTicketTriageRequest {
    status?: SupportTicketStatus
    severity?: SupportTicketSeverity | null
    /**
     * Optional note included in the follow-up email sent to the submitter
     * when the ticket transitions into RESOLVED or CLOSED.
     */
    adminNote?: string
}

export interface SupportTicketRecipient {
    id: number
    email: string
    dateAdded: number | string
    addedBy?: SimpleIdentity | null
}

export const SUPPORT_TICKET_CATEGORY_LABELS: Record<SupportTicketCategory, string> = {
    [SupportTicketCategory.BUG]: 'Bug',
    [SupportTicketCategory.FEATURE_REQUEST]: 'Feature Request',
    [SupportTicketCategory.QUESTION]: 'Question',
    [SupportTicketCategory.OTHER]: 'Other',
}

export const SUPPORT_TICKET_STATUS_LABELS: Record<SupportTicketStatus, string> = {
    [SupportTicketStatus.OPEN]: 'Open',
    [SupportTicketStatus.IN_PROGRESS]: 'In Progress',
    [SupportTicketStatus.RESOLVED]: 'Resolved',
    [SupportTicketStatus.CLOSED]: 'Closed',
}

export const SUPPORT_TICKET_SEVERITY_LABELS: Record<SupportTicketSeverity, string> = {
    [SupportTicketSeverity.LOW]: 'Low',
    [SupportTicketSeverity.MEDIUM]: 'Medium',
    [SupportTicketSeverity.HIGH]: 'High',
    [SupportTicketSeverity.CRITICAL]: 'Critical',
}
